import { createSlice } from '@reduxjs/toolkit';

const analyticsSlice = createSlice({
    name: 'analytics',
    initialState: {
        loadingMenu: false,
        requestStudentsPending: 0,
        requestInvoicePending: 0,
    },
    reducers: {
        getRequestStudentsPendingStart: (state) => {
            state.loadingMenu = true;
        },
        getRequestStudentsPendingSuccess: (state, { payload: { requestTotalPending } }) => {
            state.loadingMenu = false;
            state.requestStudentsPending = requestTotalPending;
        },
        getRequestInvoicePendingSuccess: (state, { payload: { requestTotalPending } }) => {
            state.loadingMenu = false;
            state.requestInvoicePending = requestTotalPending;
        },
        getRequestStudentsPendingFailure: (state) => {
            state.loadingMenu = false;
        },
    },
});

export const {
    getRequestStudentsPendingStart,
    getRequestStudentsPendingSuccess,
    getRequestInvoicePendingSuccess,
    getRequestStudentsPendingFailure,
} = analyticsSlice.actions;
export default analyticsSlice.reducer;